<template>

  <div class="service__details">
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="7"
        md="9"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h1 class="custom-header-title">
              View All Deceased
            </h1>
          </b-col>
        </b-row>
      </b-col>
      <b-col
        class="content-header-right text-right mb-1"
        md="3"
        cols="5"
      >
        <b-button
          v-if="canViewThisAction('add-exercised-for', 'File') && ['Niche', 'Funeral Service Package'].includes(fileDetail.nvsFileType) && fileDetail.maxDeceasedUser > exercisedForData.length"
          variant="success"
          :disabled="(fileDetail.nvsFileStatus == 'OPEN' || fileDetail.nvsFileStatus == 'BOOK') && !fileDetail.isAllowedExercising"
          class="ml-auto"
          @click="openExercisedForAddModal"
        >
          <feather-icon
            icon="PlusIcon"
            class="mr-50"
            size="16"
          />
          Add
        </b-button>
        <b-button
          v-else-if="canViewThisAction('add-exercised-for', 'File') && ['Niche', 'Funeral Service Package'].includes(fileDetail.nvsFileType)"
          v-b-tooltip.hover="'You’ve reached the maximum number of exercised for person for this file.'"
          variant="success"
          class="ml-auto"
          style="opacity: 0.65;"
          aria-readonly=""
        >
          <feather-icon
            icon="PlusIcon"
            class="mr-50"
            size="16"
          />
          Add
        </b-button>
      </b-col>
    </b-row>
    <!-- Table Container Card -->

    <b-card
      ref="taskListBlock"
      class="mb-3 p-2 without__bg must__bg ex_bg extra__bg"
      no-body
    >
      <b-row
        class="match-height"
      >
        <b-col
          v-for="(iu, key) in exercisedForData"
          :key="'iu' + key"
          md="4"
        >
          <b-card
            class="card-transaction iu-card"
            no-body
          >
            <b-card-header class="no-bottom-border">
              <b-card-title>Exercised for (#{{ key + 1 }})</b-card-title>
              <b-dropdown
                variant="link"
                no-caret
                class="chart-dropdown"
                toggle-class="p-0"
                right
              >
                <template #button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="18"
                    class="text-body cursor-pointer"
                  />
                </template>
                <b-dropdown-item
                  v-if="canViewThisAction('edit-exercised-for', 'File')"
                  @click="openExercisedForEditModal(iu)"
                >
                  Edit
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="canViewThisAction('delete-exercised-for', 'File')"
                  @click="showExercisedForRemoveWarning(iu)"
                >
                  Remove
                </b-dropdown-item>
              </b-dropdown>
            </b-card-header>
            <b-card-body>
              <b-button
                v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                variant="none"
                class="weight-600 align-middle not-button text-uppercase"
              >
                {{ iu.name }} {{ iu.chineseName }}
              </b-button>
              <br>
              <div
                v-if="iu.showFullNric"
                class="my-25"
              >
                <span class="text-uppercase mr-50">{{ iu.nric }}</span>
                <b-button
                  variant="primary"
                  size="sm"
                  class="px-50"
                  @click="iu.showFullNric = false"
                >
                  Hide full NRIC
                </b-button>
              </div>
              <div
                v-else
                class="my-25"
              >
                <span class="text-uppercase mr-50">{{ iu.encryptedNric || '-' }}</span>
                <b-button
                  v-if="canViewThisAction('view-nric', 'NRIC') && iu.nric"
                  variant="primary"
                  size="sm"
                  class="px-50"
                  @click="iu.showFullNric = true"
                >
                  Show full NRIC
                </b-button>
              </div>
              <span>
                <b-img
                  height="22"
                  :src="require('@/assets/images/admin/birthday.png')"
                  alt="Left image"
                  class="mr-25 mb-25"
                />
                {{ iu.dob ? dateFormat(iu.dob) : '-' }}
              </span>
              <br>
              <span>
                <b-img
                  height="22"
                  :src="require('@/assets/images/admin/birthday.png')"
                  alt="Left image"
                  class="mr-25 mb-25"
                />
                {{ iu.chineseDob || '-' }}
              </span>
              <br>
              <b-table-simple
                borderless
                responsive
                class="particulars_of_deceased ex-table d-none d-md-block"
              >
                <b-tbody>
                  <b-tr>
                    <b-th width="230px">
                      Exercise date
                    </b-th>
                    <b-td>{{ iu.exerciseDate ? dateFormat(iu.exerciseDate) : '-' }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th width="230px">
                      Death Date
                    </b-th>
                    <b-td>{{ iu.dod ? dateFormat(iu.dod) : '-' }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th width="230px">
                      Chinese Death Date
                    </b-th>
                    <b-td>{{ iu.chineseDod || '-' }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th width="230px">
                      Added on
                    </b-th>
                    <b-td>{{ iu.createdDate ? dateFormat(iu.createdDate) : '-' }}</b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>

              <hr>

              <b-table-simple
                borderless
                responsive
                class="particulars_of_deceased ex-table d-none d-md-block"
              >
                <b-tbody>
                  <b-tr>
                    <b-th width="230px">
                      Sex
                    </b-th>
                    <b-td class="text-uppercase">
                      {{ iu.sex || '-' }}
                    </b-td>
                  </b-tr>
                  <!-- <b-tr>
                    <b-th width="230px">
                      Religion
                    </b-th>
                    <b-td class="text-uppercase">
                      {{ iu.religion || '-' }}
                    </b-td>
                  </b-tr> -->
                  <b-tr>
                    <b-th width="230px">
                      Marital Status
                    </b-th>
                    <b-td class="text-uppercase">
                      {{ iu.maritalStatus || '-' }}
                    </b-td>
                  </b-tr>
                  <b-tr>
                    <b-th width="230px">
                      Nationality
                    </b-th>
                    <b-td class="text-uppercase">
                      {{ iu.nationality || '-' }}
                    </b-td>
                  </b-tr>
                  <b-tr>
                    <b-th width="230px">
                      Cremation Cert
                    </b-th>
                    <b-td class="text-uppercase">
                      {{ iu.cremationCertificate || '-' }}
                    </b-td>
                  </b-tr>
                  <b-tr>
                    <b-th width="230px">
                      Reference No.
                    </b-th>
                    <b-td class="text-uppercase">
                      {{ iu.referenceNo || '-' }}
                    </b-td>
                  </b-tr>
                  <b-tr>
                    <b-th width="230px">
                      Funeral Address 1
                    </b-th>
                    <b-td class="text-uppercase">
                      {{ iu.address1 || '-' }}
                    </b-td>
                  </b-tr>
                  <b-tr>
                    <b-th width="230px">
                      Funeral Address 2
                    </b-th>
                    <b-td class="text-uppercase">
                      {{ iu.address2 || '-' }}
                    </b-td>
                  </b-tr>
                  <b-tr>
                    <b-th width="230px">
                      Bury Created By
                    </b-th>
                    <b-td>{{ getBuryCreator(iu) }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th width="230px">
                      Bury Created On
                    </b-th>
                    <b-td>{{ iu.buryCreatedDate ? dateFormat(iu.buryCreatedDate) : '-' }}</b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-card>

    <b-modal
      id="modal-exercised-user"
      ref="exercised_for_modal"
      modal-class="status-update-modal iu-modal"
      cancel-variant="flat-primary"
      ok-variant="primary"
      ok-title="Save Changes"
      cancel-title="Cancel"
      centered
      no-close-on-backdrop
      :title="exercisedModalTitle"
      size="lg"
      @ok="exercisedForSubmitForm"
    >
      <b-form @submit.prevent="exercisedForSubmitForm">
        <validation-observer
          ref="exercisedForm"
        >
          <template v-if="exercisedModalTitle == 'Add Exercised For Person'">
            <validation-provider
              #default="{ errors }"
              name="Pre-fill from Intended User(s)"
              vid="intendedUser"
              rules=""
            >
              <b-form-group
                label="Pre-fill from Intended User(s)"
                label-for="h-iu-intendedUser"
                :state="(errors.length > 0) ? false : null"
              >
                <v-select
                  id="h-iu-intendedUser"
                  v-model="intendedUser"
                  :options="fileDetail.intendedUsers"
                  :clearable="true"
                  label="name"
                  :reduce="op => op.entityID"
                  placeholder="Select from list"
                  class="text-uppercase"
                  :disabled="isIntendedDisabled"
                  @input="getIntendedUserData"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
            <hr class="mx-n215">
          </template>
          <b-tabs class="exercised-for-tab">
            <b-tab
              title="Basic Fields"
              active
            >
              <b-row>
                <b-col md="12">
                  <b-form-group
                    label="Exercise date*"
                    label-for="h-exerciseDate"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Exercise date"
                      vid="exerciseDate"
                      rules="required"
                    >
                      <b-input-group>
                        <flat-pickr
                          id="h-exerciseDate"
                          v-model="exerciseDate"
                          class="form-control flat-pickr-group"
                          placeholder="Exercise date"
                          :config="flatPickrConfig"
                        />
                        <b-input-group-append is-text>
                          <feather-icon
                            icon="CalendarIcon"
                            class="cursor-pointer"
                            data-toggle
                            size="18"
                          />
                        </b-input-group-append>
                      </b-input-group>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="NRIC*"
                    label-for="h-exercisedNric"
                    class="mb-20"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="NRIC"
                      vid="h-exercisedNric"
                      rules="required"
                    >
                      <!-- <b-form-input
                        id="h-exercisedNric"
                        v-model="exercisedNric"
                        placeholder="NRIC"
                        class="text-uppercase"
                        :disabled="isFieldsDisabled"
                        :state="(errors.length > 0) ? false : null"
                      /> -->
                      <b-input-group>
                        <b-form-input
                          id="h-exercisedNric"
                          v-model="nricQuery"
                          name="name"
                          placeholder="Search NRIC"
                          autocomplete="off"
                          tabindex="0"
                          :class="!showCustomerCrossIcon ? 'input__append-border-right' : ''"
                          :disabled="showCustomerCrossIcon || exerciseEditMode"
                          style="margin-bottom: 0;"
                          @keyup="fetchResults()"
                          @focusout="resetCustomerSearchResult"
                        />
                        <b-input-group-append
                          v-if="showCustomerCrossIcon"
                          is-text
                        >
                          <feather-icon
                            icon="XIcon"
                            class="cursor-pointer text-primary"
                            size="18"
                            data-toggle
                            @click="clearCustomerSearchInput"
                          />
                        </b-input-group-append>
                      </b-input-group>
                      <div
                        v-show="showCustomerSearchResult"
                        class="search-results mt-50 z-index-99"
                      >
                        <div v-if="foundCustomers.length">
                          <b-list-group flush>
                            <b-list-group-item>
                              <h3 class="mb-0 result-search-header">
                                Customers found
                              </h3>
                            </b-list-group-item>
                            <b-list-group-item
                              v-for="(customer, cIndex) in foundCustomers"
                              :key="cIndex"
                              class="cursor-pointer"
                              @click="setCustomer(customer)"
                            >
                              <h6 class="mb-0 fs-14 text-primary">
                                {{ customer.name }}
                              </h6>
                              <p class="mb-0 fs-12">
                                {{ customer.perContact }} / {{ customer.encryptedNric }} {{ customer.perEmail ? `/ ${customer.perEmail}` : '' }}
                              </p>
                            </b-list-group-item>
                          </b-list-group>
                        </div>
                      </div>
                      <div
                        v-show="searchCustomerResultNotFound"
                        class="search-results mt-50 z-index-99"
                      >
                        <b-list-group>
                          <b-list-group-item>
                            <h3 class="mb-0 result-search-header z-index-99">
                              No result found.
                            </h3>
                          </b-list-group-item>
                        </b-list-group>
                      </div>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <validation-provider
                    #default="{ errors }"
                    name="Relationship to Purchaser"
                    vid="exercisedRelationship"
                    rules="required"
                  >
                    <b-form-group
                      label="Relationship to Purchaser*"
                      label-for="h-exercisedRelationship"
                      :state="(errors.length > 0) ? false : null"
                    >
                      <v-select
                        id="h-exercisedRelationship"
                        v-model="exercisedRelationship"
                        :options="relationshipOptions"
                        :clearable="false"
                        :disabled="(exerciseEditMode && Boolean(intendedUser)) || (isFieldsDisabled && !isIntendedDisabled)"
                        placeholder="Select from list"
                        class="text-uppercase"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="Name*"
                    label-for="h-exercisedName"
                    class="mb-20"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Name"
                      vid="h-exercisedName"
                      rules="required"
                    >
                      <b-form-input
                        id="h-exercisedName"
                        v-model="exercisedName"
                        placeholder="Name"
                        class="text-uppercase"
                        :disabled="isFieldsDisabled || exerciseEditMode"
                        :state="(errors.length > 0) ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="Chinese Name"
                    label-for="h-exercisedChineseName"
                    class="mb-20"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Chinese Name"
                      vid="h-exercisedChineseName"
                      rules=""
                    >
                      <b-form-input
                        id="h-exercisedChineseName"
                        v-model="exercisedChineseName"
                        placeholder="Chinese Name"
                        :state="(errors.length > 0) ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group
                    label="Date of Birth"
                    label-for="h-exercisedDob"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Date of Birth"
                      vid="exercisedDob"
                      rules=""
                    >
                      <b-input-group>
                        <flat-pickr
                          id="h-exercisedDob"
                          v-model="exercisedDob"
                          class="form-control flat-pickr-group"
                          placeholder="Date of Birth"
                          :config="flatPickrConfig"
                          :disabled="isFieldsDisabled || exerciseEditMode"
                        />
                        <b-input-group-append is-text>
                          <feather-icon
                            icon="CalendarIcon"
                            class="cursor-pointer"
                            data-toggle
                            size="18"
                          />
                        </b-input-group-append>
                      </b-input-group>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="Chinese Date of Birth"
                    label-for="h-exercisedChineseDob"
                    class="mb-20"
                  >
                    <div class="d-flex align-items-center gap-1">
                      <validation-provider
                        #default="{ errors }"
                        name="Chinese Year of Birth"
                        vid="h-exercisedChineseDobYear"
                        rules=""
                      >
                        <b-input-group
                          class="input-group-merge text-mb-0"
                          append="年"
                        >
                          <b-form-input
                            id="h-exercisedChineseDobYear"
                            v-model="exercisedChineseDobYear"
                            type="text"
                            placeholder="Year"
                          />
                        </b-input-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                      <validation-provider
                        #default="{ errors }"
                        name="Chinese Month of Birth"
                        vid="h-exercisedChineseDobMonth"
                        rules=""
                      >
                        <b-input-group
                          class="input-group-merge text-mb-0"
                          append="月"
                        >
                          <b-form-input
                            id="h-exercisedChineseDobMonth"
                            v-model="exercisedChineseDobMonth"
                            type="text"
                            placeholder="Month"
                          />
                        </b-input-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                      <validation-provider
                        #default="{ errors }"
                        name="Chinese Day of Birth"
                        vid="h-exercisedChineseDobDay"
                        rules=""
                      >
                        <b-input-group
                          class="input-group-merge text-mb-0"
                          append="日"
                        >
                          <b-form-input
                            id="h-exercisedChineseDobDay"
                            v-model="exercisedChineseDobDay"
                            type="text"
                            placeholder="Day"
                          />
                        </b-input-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </div>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="Death Date"
                    label-for="h-exercisedDod"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Death Date"
                      vid="exercisedDod"
                      rules=""
                    >
                      <b-input-group>
                        <flat-pickr
                          id="h-exercisedDod"
                          v-model="exercisedDod"
                          class="form-control flat-pickr-group"
                          placeholder="Death Date"
                          :config="flatPickrConfig"
                        />
                        <b-input-group-append is-text>
                          <feather-icon
                            icon="CalendarIcon"
                            class="cursor-pointer"
                            data-toggle
                            size="18"
                          />
                        </b-input-group-append>
                      </b-input-group>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <!-- <b-col md="6">
                  <b-form-group
                    label="Chinese Death Date"
                    label-for="h-exercisedChineseDod"
                    class="mb-20"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Chinese Death Date"
                      vid="h-exercisedChineseDod"
                      rules=""
                    >
                      <b-form-input
                        id="h-exercisedChineseDod"
                        v-model="exercisedChineseDod"
                        placeholder="Chinese Death Date"
                        :state="(errors.length > 0) ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col> -->
                <b-col md="6">
                  <b-form-group
                    label="Chinese Death Date"
                    label-for="h-exercisedChineseDod"
                    class="mb-20"
                  >
                    <div class="d-flex align-items-center gap-1">
                      <validation-provider
                        #default="{ errors }"
                        name="Chinese Year of Death"
                        vid="h-exercisedChineseDodYear"
                        rules=""
                      >
                        <b-input-group
                          class="input-group-merge text-mb-0"
                          append="年"
                        >
                          <b-form-input
                            id="h-exercisedChineseDodYear"
                            v-model="exercisedChineseDodYear"
                            type="text"
                            placeholder="Year"
                          />
                        </b-input-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                      <validation-provider
                        #default="{ errors }"
                        name="Chinese Month of Death"
                        vid="h-exercisedChineseDodMonth"
                        rules=""
                      >
                        <b-input-group
                          class="input-group-merge text-mb-0"
                          append="月"
                        >
                          <b-form-input
                            id="h-exercisedChineseDodMonth"
                            v-model="exercisedChineseDodMonth"
                            type="text"
                            placeholder="Month"
                          />
                        </b-input-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                      <validation-provider
                        #default="{ errors }"
                        name="Chinese Day of Death"
                        vid="h-exercisedChineseDodDay"
                        rules=""
                      >
                        <b-input-group
                          class="input-group-merge text-mb-0"
                          append="日"
                        >
                          <b-form-input
                            id="h-exercisedChineseDodDay"
                            v-model="exercisedChineseDodDay"
                            type="text"
                            placeholder="Day"
                          />
                        </b-input-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab
              title="Extended Information"
            >
              <b-alert
                v-if="isFieldsDisabled"
                variant="warning"
                show
                class=""
              >
                <div class="alert-body has-radius">
                  <span class="d-flex align-items-center">
                    <feather-icon
                      size="20"
                      icon="AlertCircleIcon"
                      class="mr-25"
                      style="top: 0;"
                    /> <div class="alert_text weight-400">Sex, Marital Status and Nationality will be saved to this person’s Customer profile.</div>
                  </span>
                </div>
              </b-alert>
              <b-row>
                <b-col md="6">
                  <validation-provider
                    #default="{ errors }"
                    name="Sex"
                    vid="exercisedSex"
                    rules=""
                  >
                    <b-form-group
                      label="Sex"
                      label-for="h-exercisedSex"
                      :state="(errors.length > 0) ? false : null"
                    >
                      <v-select
                        id="h-exercisedSex"
                        v-model="exercisedSex"
                        :options="genderOptions"
                        label="title"
                        :clearable="false"
                        :reduce="title => title.code"
                        placeholder="Select from list"
                        class="text-uppercase"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <!-- <b-col md="6">
                  <validation-provider
                    #default="{ errors }"
                    name="Religion"
                    vid="exercisedReligion"
                    rules=""
                  >
                    <b-form-group
                      label="Religion"
                      label-for="h-exercisedReligion"
                      :state="(errors.length > 0) ? false : null"
                    >
                      <v-select
                        id="h-exercisedReligion"
                        v-model="exercisedReligion"
                        :options="religionOptions"
                        label="text"
                        :clearable="false"
                        :reduce="title => title.value"
                        placeholder="Select from list"
                        class="text-uppercase"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col> -->
                <b-col md="6">
                  <validation-provider
                    #default="{ errors }"
                    name="Marital Status"
                    vid="exercisedMaritalStatus"
                    rules=""
                  >
                    <b-form-group
                      label="Marital Status"
                      label-for="h-exercisedMaritalStatus"
                      :state="(errors.length > 0) ? false : null"
                    >
                      <v-select
                        id="h-exercisedMaritalStatus"
                        v-model="exercisedMaritalStatus"
                        :options="maritalOptions"
                        label="title"
                        :clearable="false"
                        :reduce="title => title.code"
                        placeholder="Select from list"
                        class="text-uppercase"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col md="6">
                  <validation-provider
                    #default="{ errors }"
                    name="Nationality"
                    vid="exercisedNationality"
                    rules=""
                  >
                    <b-form-group
                      label="Nationality"
                      label-for="h-exercisedNationality"
                      :state="(errors.length > 0) ? false : null"
                    >
                      <v-select
                        id="h-exercisedNationality"
                        v-model="exercisedNationality"
                        label="title"
                        :options="nationalityOptions"
                        :reduce="title => title.code"
                        :clearable="false"
                        placeholder="Select from list"
                        class="text-uppercase"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="Cremation Cert"
                    label-for="h-exercisedCremationCertificate"
                    class="mb-20"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Cremation Cert"
                      vid="h-exercisedCremationCertificate"
                      rules=""
                    >
                      <b-form-input
                        id="h-exercisedCremationCertificate"
                        v-model="exercisedCremationCertificate"
                        placeholder="Cremation Cert"
                        class="text-uppercase"
                        :state="(errors.length > 0) ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group
                    label="Reference No."
                    label-for="h-exercisedReferenceNo"
                    class="mb-20"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Reference No."
                      vid="h-exercisedReferenceNo"
                      rules=""
                    >
                      <b-form-input
                        id="h-exercisedReferenceNo"
                        v-model="exercisedReferenceNo"
                        placeholder="Reference No."
                        class="text-uppercase"
                        :state="(errors.length > 0) ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group
                    label="Funeral Address 1"
                    label-for="h-exercisedAddress1"
                    class="mb-20"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Funeral Address 1"
                      vid="h-exercisedAddress1"
                      rules=""
                    >
                      <b-form-input
                        id="h-exercisedAddress1"
                        v-model="exercisedAddress1"
                        placeholder="Funeral Address 1"
                        class="text-uppercase"
                        :state="(errors.length > 0) ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group
                    label="Funeral Address 2"
                    label-for="h-exercisedAddress2"
                    class="mb-20"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Funeral Address 2"
                      vid="h-exercisedAddress2"
                      rules=""
                    >
                      <b-form-input
                        id="h-exercisedAddress2"
                        v-model="exercisedAddress2"
                        placeholder="Funeral Address 2"
                        class="text-uppercase"
                        :state="(errors.length > 0) ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <!-- <b-col md="6">
                  <validation-provider
                    #default="{ errors }"
                    name="Bury Created By"
                    vid="buryCreatedBy"
                    rules=""
                  >
                    <b-form-group
                      label="Bury Created By"
                      label-for="h-buryCreatedBy"
                      :state="(errors.length > 0) ? false : null"
                    >
                      <v-select
                        id="h-buryCreatedBy"
                        v-model="buryCreatedBy"
                        :options="createdByOptions"
                        label="title"
                        :clearable="false"
                        :reduce="title => title.code"
                        placeholder="Select from list"
                        class="text-uppercase"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="Bury Created On"
                    label-for="h-buryCreatedAt"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Bury Created On"
                      vid="buryCreatedAt"
                      rules=""
                    >
                      <b-input-group>
                        <flat-pickr
                          id="h-buryCreatedAt"
                          v-model="buryCreatedAt"
                          class="form-control flat-pickr-group"
                          placeholder="Bury Created On"
                          :config="flatPickrConfig"
                        />
                        <b-input-group-append is-text>
                          <feather-icon
                            icon="CalendarIcon"
                            class="cursor-pointer"
                            data-toggle
                            size="18"
                          />
                        </b-input-group-append>
                      </b-input-group>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col> -->
              </b-row>
            </b-tab>
          </b-tabs>
        </validation-observer>
      </b-form>
      <div
        v-if="fileDetail.deceased && !fileDetail.deceased.length"
        class="mt-1 text-center px-3"
      >
        <small class="text-muted"><strong>Note:</strong> This is the first Exercised For person being added to the file. If you proceed, the system will automatically update this file’s exercise status to ‘Exercised’.</small>
      </div>
      <template #modal-footer="{ ok, cancel }">
        <b-button
          variant="link"
          @click="cancel()"
        >
          Cancel
        </b-button>
        <b-button
          v-if="exercisedForEditID"
          variant="success"
          @click="ok()"
        >
          <span class="align-middle">Edit Exercised For Person</span>
        </b-button>
        <b-button
          v-else
          variant="success"
          class="custom-icon"
          @click="ok()"
        >
          <feather-icon
            icon="PlusIcon"
            size="16"
            class="mr-50"
          />
          <span class="align-middle">Add Exercised For Person</span>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard, BRow, BButton, BCol, BImg, BForm, BFormGroup, BCardTitle, BCardHeader, BCardBody, BTableSimple, BTbody, BTr, BTh, BTd, BAlert,
  BFormInput, VBTooltip, VBToggle, BTabs, BTab, BDropdown, BDropdownItem, BInputGroup, BInputGroupAppend, BListGroup, BListGroupItem,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
// import Cleave from 'vue-cleave-component'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'cleave.js/dist/addons/cleave-phone.us'
import vSelect from 'vue-select'
import store from '@/store/index'
import { required } from '@validations'
import '@core/scss/vue/libs/vue-flatpicker.scss'
import flatPickr from 'vue-flatpickr-component'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import moment from 'moment'
import { useUtils as useAclUtils } from '@/libs/acl/custom'
import ToastificationContentCustom from '../../operation/ToastificationContentCustom.vue'

const { canViewThisAction } = useAclUtils()

export default {
  components: {
    BCard,
    BCardTitle,
    BCardHeader,
    BCardBody,
    BRow,
    BButton,
    BCol,
    BImg,
    BForm,
    BFormGroup,
    BFormInput,
    BTabs,
    BTab,
    BDropdown,
    BDropdownItem,
    BInputGroup,
    BInputGroupAppend,
    BTableSimple,
    BTbody,
    BTr,
    BTh,
    BTd,
    BListGroup,
    BListGroupItem,
    BAlert,

    vSelect,
    // Cleave,
    flatPickr,
    ValidationProvider,
    ValidationObserver,
  },
  directives: { 'b-toggle': VBToggle, 'b-tooltip': VBTooltip, Ripple },
  data() {
    return {
      canViewThisAction,
      user: store.state.auth.userData,
      fileDetail: {},
      // fileDetail: JSON.parse(localStorage.getItem('customerFileNominees')),
      fileDetailID: '',
      fileDetailActivityLogs: [],
      required,
      // eslint-disable-next-line global-require
      defaultImage: require('@/assets/images/frontend/logo-nirvana-memorial-garden.86fe2ff5.svg'),
      exercisedModalTitle: 'Add Exercised For Person',
      intendedUser: '',
      buryID: '',
      updatedDate: '',
      exerciseDate: '',
      exercisedName: '',
      exercisedChineseName: '',
      exercisedNric: '',
      exercisedRelationship: '',
      exercisedChineseDobDay: '',
      exercisedChineseDobMonth: '',
      exercisedChineseDobYear: '',
      exercisedDob: '',
      exercisedChineseDob: '',
      exercisedDod: '',
      exercisedChineseDod: '',
      exercisedChineseDodDay: '',
      exercisedChineseDodMonth: '',
      exercisedChineseDodYear: '',
      exercisedSex: '',
      exercisedReligion: '',
      exercisedMaritalStatus: '',
      exercisedNationality: '',
      exercisedCremationCertificate: '',
      exercisedReferenceNo: '',
      exercisedAddress1: '',
      exercisedAddress2: '',
      buryCreatedBy: '',
      buryCreatedAt: '',
      exercisedForEditID: '',
      exercisedCustomer: '',
      exercisedEntity: '',
      nricQuery: '',
      exerciseEditMode: false,
      isIntendedDisabled: false,
      isFieldsDisabled: false,
      showCustomerCrossIcon: false,
      showCustomerSearchResult: false,
      searchCustomerResultNotFound: false,
      foundCustomers: [],
      timeout: null,
      flatPickrConfig: {
        wrap: true, enableTime: false, static: true, dateFormat: 'd/m/Y', disableMobile: true,
      },
      genderOptions: [
        { title: 'MALE', code: 'MALE' },
        { title: 'FEMALE', code: 'FEMALE' },
        { title: 'N/A', code: 'N/A' },
      ],
      religionOptions: [
        { text: 'Buddhist', value: 'Buddhist' },
        { text: 'Taoist', value: 'Taoist' },
        { text: 'Christian', value: 'Christian' },
        { text: 'Soka', value: 'Soka' },
        { text: 'Catholic', value: 'Catholic' },
        { text: 'Free thinker', value: 'Free thinker' },
        { text: 'Others', value: 'Others' },
      ],
      relationshipOptions: [
        'Brother', 'Brother in-law', 'Cousin', 'Daughter', 'Daughter in-law', 'Elder Brother', 'Father', 'Father in-law',
        'Friend', 'God-father', 'Grand Daughter', 'Grandfather', 'Grandmother', 'Grandson', 'Great Grand Father',
        'Great Grand Mother', 'Husband', 'Mother', 'Mother in-law', 'N/A', 'Nephew', 'Niece', 'Relative', 'Self', 'Sister',
        'Sister in-law', 'Son', 'Son in-law', 'Uncle', 'Wife',
      ],
      maritalOptions: [
        { title: 'DIVORCED', code: 'DIVORCED' },
        { title: 'MARRIED', code: 'MARRIED' },
        { title: 'OTHERS', code: 'OTHERS' },
        { title: 'SINGLE', code: 'SINGLE' },
      ],
      createdByOptions: [],
      countryOptions: ['SINGAPORE', 'MALAYSIA', 'OTHERS'],
      nationalityOptions: [
        { title: 'SINGAPOREAN', code: 'SINGAPOREAN' },
        { title: 'MALAYSIAN', code: 'MALAYSIAN' },
        { title: 'OTHERS', code: 'OTHERS' },
      ],
      flatPickrConfigWithoutTime: {
        wrap: true, enableTime: false, dateFormat: 'd/m/Y', disableMobile: true, static: true,
      },
      addModalTitle: 'Add Intended User',
      editModalTitle: 'Edit Intended User',
      iuContactValidation: false,
      iuContactError: 'The Mobile No. field is required',
      options: {
        prefix: {
          numericOnly: true,
          prefix: '+65',
          blocks: [3, 8],
        },
      },
      exercisedForData: [],
    }
  },
  mounted() {
    window.scrollTo(0, 0)
    this.fetchFileDetail()
    // document.title = `${this.fileDetail.fileNo} - ${this.fileDetail.nvsFileType} | ${process.env.VUE_APP_APP_NAME || 'Nirvana Memorial Garden'}`
    // store.commit('breadcrumb/REMOVE_BREADCRUMB')
    // store.commit('breadcrumb/REMOVE_BREADCRUMB')
    // store.commit('breadcrumb/REMOVE_BREADCRUMB')
    // const newFirstMeta = {
    //   to: '/customers/files',
    //   text: 'Files',
    // }
    // store.commit('breadcrumb/UPDATE_BREADCRUMB', newFirstMeta)
    // const newSecondMeta = {
    //   to: `/customers/files/${this.$route.params.id}/show`,
    //   text: `${this.fileDetail.fileNo} - ${this.fileDetail.nvsFileType}`,
    // }
    // store.commit('breadcrumb/UPDATE_BREADCRUMB', newSecondMeta)
    // const newThirdMeta = {
    //   active: true,
    //   text: 'View All Related Nominees',
    // }
    // store.commit('breadcrumb/UPDATE_BREADCRUMB', newThirdMeta)
  },
  methods: {
    fetchFileDetail() {
      this.$http.get(`customer/files/${this.$route.params.id}/deceased`)
        .then(response => {
          this.fileDetail = response.data.file || {}
          document.title = `File - ${this.fileDetail.fileNo} | ${process.env.VUE_APP_APP_NAME || 'Nirvana Memorial Garden'}`
          // localStorage.setItem('customerFileNominees', JSON.stringify(this.fileDetail))
          store.commit('breadcrumb/REMOVE_BREADCRUMB')
          store.commit('breadcrumb/REMOVE_BREADCRUMB')
          store.commit('breadcrumb/REMOVE_BREADCRUMB')
          const newFirstMeta = {
            to: '/customers/files',
            text: 'Files',
          }
          store.commit('breadcrumb/UPDATE_BREADCRUMB', newFirstMeta)
          const newSecondMeta = {
            to: `/customers/files/${this.$route.params.id}/show`,
            text: `${this.fileDetail.fileNo} - ${this.fileDetail.nvsFileType}`,
          }
          store.commit('breadcrumb/UPDATE_BREADCRUMB', newSecondMeta)
          const newThirdMeta = {
            active: true,
            text: 'View All Deceased',
          }
          store.commit('breadcrumb/UPDATE_BREADCRUMB', newThirdMeta)

          this.generateDeceasedData()
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    getBuryCreator(iu) {
      if (iu.createdByNvs) {
        return iu.createdByNvs.name
      }
      if (iu.buryCreatedBy) {
        return iu.buryCreatedBy
      }

      return '-'
    },
    generateDeceasedData() {
      this.exercisedForData = this.fileDetail.deceased.map(item => ({
        ...item,
        showFullNric: false,
      }))
    },
    isRecentlyConfirmed() {
      if (!this.fileDetail.confirmDate) return false
      const confirmDate = moment(this.fileDetail.confirmDate)
      return this.fileDetail.nvsFileType === 'Funeral Service Package' && confirmDate.isAfter(moment().subtract(30, 'days'))
    },
    fetchResults() {
      const query = this.nricQuery

      if (query && query.length > 2) {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.$http.get('appointment/bookings/respond-with/customers', { params: { search: query } })
            .then(response => {
              if (response.data.customers.length === 0) {
                this.foundCustomers = []
                this.searchCustomerResultNotFound = true
                this.showCustomerSearchResult = false
              } else {
                this.foundCustomers = response.data.customers
                this.showCustomerSearchResult = true
                this.searchCustomerResultNotFound = false
              }
              this.exercisedCustomer = ''
              this.exercisedEntity = ''
              this.exercisedName = ''
              this.exercisedNric = ''
              this.exercisedRelationship = ''
              this.exercisedDob = ''
              this.exercisedSex = ''
              this.exercisedNationality = ''
              this.exercisedMaritalStatus = ''
              this.isFieldsDisabled = false
              this.isIntendedDisabled = false
            })
            .catch(error => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              })
            })
        }, this.debounceMilliseconds)
      }
    },
    setCustomer(customer) {
      this.showCustomerCrossIcon = true
      this.nricQuery = customer.nric
      this.exercisedCustomer = customer ? customer._id : ''
      this.exercisedEntity = customer.entityID
      this.exercisedName = customer.name
      this.exercisedNric = customer.nric
      this.exercisedRelationship = ''
      this.exercisedDob = customer.dob
      this.exercisedSex = customer ? customer.sex : ''
      this.exercisedNationality = customer ? customer.nationality : ''
      this.exercisedMaritalStatus = customer ? customer.maritalStatus : ''
      this.intendedUser = ''
      this.isFieldsDisabled = true
      this.isIntendedDisabled = true
      if (customer) {
        this.$http.get(`customer/customers/${customer._id}`)
          .then(response => {
            if (response.data.success) {
              this.exercisedMaritalStatus = response.data.data.maritalStatus || ''
              this.exercisedChineseName = response.data.data.chineseName || ''
            }
          })
      }
    },
    resetCustomerSearchResult() {
      setTimeout(() => {
        this.searchCustomerResultNotFound = false
        this.showCustomerSearchResult = false
      }, 500)
    },
    clearCustomerSearchInput() {
      this.nricQuery = ''
      this.exercisedCustomer = ''
      this.exercisedEntity = ''
      this.exercisedName = ''
      this.exercisedNric = ''
      this.exercisedRelationship = ''
      this.exercisedDob = ''
      this.exercisedSex = ''
      this.exercisedNationality = ''
      this.exercisedMaritalStatus = ''
      this.showCustomerCrossIcon = false
      this.searchCustomerResultNotFound = false
      this.showCustomerSearchResult = false
      this.isFieldsDisabled = false
      this.isIntendedDisabled = false
    },
    openExercisedForAddModal() {
      this.isFieldsDisabled = false
      this.exerciseEditMode = false
      this.exercisedModalTitle = 'Add Exercised For Person'
      this.exercisedForEditID = ''
      let title = ''
      let message = ''
      if (this.fileDetail.nvsFileStatus !== 'CONFIRM/Exercise') {
        if (this.isRecentlyConfirmed()) {
          if (this.fileDetail.paymentStatus !== 'Fully Paid') {
            title = 'Unpaid & Newly Confirmed File'
            message = 'This file is newly confirmed and has not been fully paid. Please ensure all related details are reviewed within the 30-day window before proceeding.<br><br>You can still proceed to exercise the file, but note that an email will be sent to the Collections department to follow up on payment, and you may be involved in ensuring the file is paid.<br><br>Do you wish to proceed?'
          } else {
            title = 'The confirmation occurred less than 30 days ago!'
            message = 'This file is newly confirmed—please ensure all related details are reviewed within the 30-day window before you proceed. Do you wish to proceed?'
          }
        } else if (this.fileDetail.paymentStatus !== 'Fully Paid') {
          title = 'This file is in pending payment'
          message = 'This file has not been fully paid. You can still proceed to exercise the file. Note that an email will be sent to the collections department to help ensure this file is paid, and you may be involved in ensuring file payment as well.'
        }
      }
      if (title) {
        this.$swal({
          title,
          html: message,
          // eslint-disable-next-line global-require
          imageUrl: require('@/assets/images/icons/warning.png'),
          imageWidth: 80,
          imageHeight: 80,
          imageAlt: 'Custom Icon',
          reverseButtons: true,
          showCancelButton: true,
          confirmButtonText: 'Yes, I want to continue',
          cancelButtonText: 'No, cancel',
          customClass: {
            confirmButton: 'btn btn-primary ml-1',
            cancelButton: 'btn btn-outline-primary',
          },
          buttonsStyling: false,
          width: 555,
        })
          .then(result => {
            if (result.value) {
              this.$root.$emit('bv::show::modal', 'modal-exercised-user', '')
            }
          })
      } else {
        this.$root.$emit('bv::show::modal', 'modal-exercised-user', '')
      }
    },
    openExercisedForEditModal(data) {
      this.isFieldsDisabled = true
      this.exerciseEditMode = true
      this.exercisedModalTitle = 'Edit Exercised For Person'
      this.exercisedCustomer = data.customer || ''
      this.exercisedEntity = data.entityID || ''
      this.exercisedForEditID = data._id || ''
      this.exerciseDate = data.exerciseDate ? moment(data.exerciseDate).format('DD/MM/YYYY') : ''
      this.intendedUser = data.intendedUser || ''
      // eslint-disable-next-line eqeqeq
      const iu = this.fileDetail.intendedUsers.find(o => o.entityID == data.entityID)
      if (iu) {
        this.intendedUser = data.entityID
      }
      this.buryID = data.buryID || ''
      this.updatedDate = data.updatedDate || ''
      this.exercisedName = data.name || ''
      this.exercisedChineseName = data.chineseName || ''
      this.nricQuery = data.nric || ''
      this.exercisedNric = data.nric || ''
      this.exercisedReligion = data.religion || ''
      this.exercisedMaritalStatus = data.maritalStatus || ''
      this.exercisedRelationship = data.relation || ''
      this.exercisedDob = data.dob ? moment(data.dob).format('DD/MM/YYYY') : ''
      this.exercisedChineseDobDay = data.chineseDobDay || ''
      this.exercisedChineseDobMonth = data.chineseDobMonth || ''
      this.exercisedChineseDobYear = data.chineseDobYear || ''
      this.exercisedSex = data.sex || ''
      this.exercisedNationality = data.nationality || ''
      this.exercisedDod = data.dod ? moment(data.dod).format('DD/MM/YYYY') : ''
      this.exercisedChineseDodDay = data.chineseDodDay || ''
      this.exercisedChineseDodMonth = data.chineseDodMonth || ''
      this.exercisedChineseDodYear = data.chineseDodYear || ''
      this.exercisedCremationCertificate = data.cremationCertificate || ''
      this.exercisedReferenceNo = data.referenceNo || ''
      this.exercisedAddress1 = data.address1 || ''
      this.exercisedAddress2 = data.address2 || ''
      this.buryCreatedBy = data.buryCreatedBy || ''
      this.buryCreatedAt = data.buryCreatedDate ? moment(data.buryCreatedDate).format('DD/MM/YYYY') : ''
      this.$root.$emit('bv::show::modal', 'modal-exercised-user', '')
    },
    showExercisedForRemoveWarning(data) {
      const title = `Remove ${data.name}?`
      let message = ''
      if (this.fileDetail.deceased.length === 1) {
        message = `${data.name} will no longer be registered as the Exercise For person for this file. Removing this person will also revert the file from Exercised status.<br><br>Are you sure you want to remove?`
      } else {
        message = `${data.name} will no longer be registered as the Exercise For person for this file.<br><br>Are you sure you want to remove?`
      }
      if (title) {
        this.$swal({
          title,
          html: message,
          // eslint-disable-next-line global-require
          imageUrl: require('@/assets/images/icons/delete.png'),
          imageWidth: 80,
          imageHeight: 80,
          imageAlt: 'Custom Icon',
          reverseButtons: true,
          showCancelButton: true,
          confirmButtonText: 'Yes, remove',
          cancelButtonText: 'Cancel',
          customClass: {
            confirmButton: 'btn btn-primary ml-1',
            cancelButton: 'btn btn-outline-primary',
          },
          buttonsStyling: false,
          width: 408,
        })
          .then(result => {
            if (result.value) {
              const formData = new FormData()
              formData.append('name', data.name)
              formData.append('buryID', data.buryID)
              formData.append('entityID', data.entityID)
              formData.append('exercisedForID', data._id)
              formData.append('updatedAt', data.updatedDate)
              formData.append('nvsFileID', this.fileDetail._id)

              this.$http.post(`customer/files/${this.$route.params.id}/remove/exercised-for`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
              })
                .then(response => {
                  if (response.data.success) {
                    this.$set(this.fileDetail, 'deceased', response.data.fileDetail.deceased)
                    this.$toast({
                      component: ToastificationContentCustom,
                      props: {
                        title: 'Successfully removed',
                        text: `<strong>${data.name}</strong> has no longer be registered as a Exercised For Person for this file.`,
                        icon: 'Trash2Icon',
                        variant: 'danger',
                        hideClose: true,
                      },
                    })
                    this.generateDeceasedData()
                  } else {
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: response.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                      },
                    })
                  }
                })
                .catch(error => {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                      icon: 'AlertTriangleIcon',
                      variant: 'danger',
                    },
                  })
                })
            }
          })
      }
    },
    getIntendedUserData() {
      const iu = this.fileDetail.intendedUsers.find(o => o.entityID === this.intendedUser)
      if (iu) {
        // eslint-disable-next-line prefer-destructuring
        const customer = iu.customer
        this.exercisedCustomer = customer ? customer._id : ''
        this.exercisedEntity = iu.entityID
        this.exercisedName = iu.name
        this.exercisedNric = iu.nric
        this.nricQuery = iu.nric
        this.exercisedRelationship = iu.relation
        this.exercisedDob = iu.dob
        this.exercisedSex = customer ? customer.sex : ''
        this.exercisedNationality = customer ? customer.nationality : ''
        this.exercisedMaritalStatus = customer ? customer.maritalStatus : ''
        this.isFieldsDisabled = true
        this.showCustomerCrossIcon = true
        if (customer) {
          this.$http.get(`customer/customers/${customer._id}`)
            .then(response => {
              if (response.data.success) {
                this.exercisedMaritalStatus = response.data.data.maritalStatus || ''
                this.exercisedChineseName = response.data.data.chineseName || ''
              }
            })
        }
      } else {
        this.nricQuery = ''
        this.exercisedCustomer = ''
        this.exercisedEntity = ''
        this.exercisedName = ''
        this.exercisedNric = ''
        this.exercisedRelationship = ''
        this.exercisedDob = ''
        this.exercisedSex = ''
        this.exercisedNationality = ''
        this.exercisedMaritalStatus = ''
        this.isFieldsDisabled = false
        this.showCustomerCrossIcon = false
      }
    },
    exercisedForSubmitForm(bvModalEvt) {
      bvModalEvt.preventDefault()
      this.$refs.exercisedForm.validate().then(success => {
        if (success) {
          if (this.exercisedForEditID) {
            this.exercisedForEditForm()
          } else {
            this.exercisedForCreateForm()
          }
        }
      })
    },
    exercisedForCreateForm() {
      const formData = new FormData()
      formData.append('exerciseDate', this.exerciseDate ? moment(this.exerciseDate, 'DD/MM/YYYY').format('YYYY-MM-DD') : '')
      formData.append('customer', this.exercisedCustomer)
      formData.append('entityID', this.exercisedEntity)
      formData.append('intendedUser', this.intendedUser)
      formData.append('name', this.exercisedName)
      formData.append('chineseName', this.exercisedChineseName)
      formData.append('nric', this.exercisedNric ? this.exercisedNric : this.nricQuery)
      formData.append('sex', this.exercisedSex)
      formData.append('religion', this.exercisedReligion)
      formData.append('maritalStatus', this.exercisedMaritalStatus)
      formData.append('nationality', this.exercisedNationality)
      formData.append('dob', this.exercisedDob ? moment(this.exercisedDob, 'DD/MM/YYYY').format('YYYY-MM-DD') : '')
      formData.append('chineseDobDay', this.exercisedChineseDobDay)
      formData.append('chineseDobMonth', this.exercisedChineseDobMonth)
      formData.append('chineseDobYear', this.exercisedChineseDobYear)
      formData.append('dod', this.exercisedDod ? moment(this.exercisedDod, 'DD/MM/YYYY').format('YYYY-MM-DD') : '')
      formData.append('chineseDodDay', this.exercisedChineseDodDay)
      formData.append('chineseDodMonth', this.exercisedChineseDodMonth)
      formData.append('chineseDodYear', this.exercisedChineseDodYear)
      formData.append('cremationCertificate', this.exercisedCremationCertificate)
      formData.append('referenceNo', this.exercisedReferenceNo)
      formData.append('relation', this.exercisedRelationship)
      formData.append('address1', this.exercisedAddress1)
      formData.append('address2', this.exercisedAddress2)
      formData.append('buryCreatedBy', this.buryCreatedBy)
      formData.append('buryCreatedDate', this.buryCreatedAt ? moment(this.buryCreatedAt, 'DD/MM/YYYY').format('YYYY-MM-DD') : '')
      formData.append('nvsFileID', this.fileDetail._id)

      this.$http.post(`customer/files/${this.$route.params.id}/add/exercised-for`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(response => {
          if (response.data.success) {
            this.$set(this.fileDetail, 'deceased', response.data.fileDetail.deceased)
            this.$refs.exercised_for_modal.hide()
            let text = `<strong>${this.exercisedName}</strong> has been added as the Exercise For person, and the file status has been updated to Exercised.`
            if (response.data.fileDetail.deceased.length > 1) {
              text = `<strong>${this.exercisedName}</strong> has been added as the Exercise For person.`
            }
            this.$toast({
              component: ToastificationContentCustom,
              props: {
                title: 'Successfully added',
                text,
                icon: 'CheckCircleIcon',
                variant: 'success',
                hideClose: true,
              },
            })
            this.generateDeceasedData()
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },

    exercisedForEditForm() {
      const formData = new FormData()
      formData.append('exerciseDate', this.exerciseDate ? moment(this.exerciseDate, 'DD/MM/YYYY').format('YYYY-MM-DD') : '')
      formData.append('customer', this.exercisedCustomer)
      formData.append('entityID', this.exercisedEntity)
      formData.append('buryID', this.buryID)
      formData.append('updatedAt', this.updatedDate)
      formData.append('intendedUser', this.intendedUser)
      formData.append('name', this.exercisedName)
      formData.append('chineseName', this.exercisedChineseName)
      formData.append('nric', this.exercisedNric ? this.exercisedNric : this.nricQuery)
      formData.append('sex', this.exercisedSex)
      formData.append('religion', this.exercisedReligion)
      formData.append('maritalStatus', this.exercisedMaritalStatus)
      formData.append('nationality', this.exercisedNationality)
      formData.append('dob', this.exercisedDob ? moment(this.exercisedDob, 'DD/MM/YYYY').format('YYYY-MM-DD') : '')
      formData.append('chineseDobDay', this.exercisedChineseDobDay)
      formData.append('chineseDobMonth', this.exercisedChineseDobMonth)
      formData.append('chineseDobYear', this.exercisedChineseDobYear)
      formData.append('dod', this.exercisedDod ? moment(this.exercisedDod, 'DD/MM/YYYY').format('YYYY-MM-DD') : '')
      formData.append('chineseDodDay', this.exercisedChineseDodDay)
      formData.append('chineseDodMonth', this.exercisedChineseDodMonth)
      formData.append('chineseDodYear', this.exercisedChineseDodYear)
      formData.append('cremationCertificate', this.exercisedCremationCertificate)
      formData.append('referenceNo', this.exercisedReferenceNo)
      formData.append('relation', this.exercisedRelationship)
      formData.append('address1', this.exercisedAddress1)
      formData.append('address2', this.exercisedAddress2)
      formData.append('buryCreatedBy', this.buryCreatedBy)
      formData.append('buryCreatedDate', this.buryCreatedAt ? moment(this.buryCreatedAt, 'DD/MM/YYYY').format('YYYY-MM-DD') : '')
      formData.append('nvsFileID', this.fileDetail._id)
      formData.append('editID', this.exercisedForEditID)

      this.$http.post(`customer/files/${this.$route.params.id}/edit/exercised-for`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(response => {
          if (response.data.success) {
            this.$set(this.fileDetail, 'deceased', response.data.fileDetail.deceased)
            this.$refs.exercised_for_modal.hide()
            this.$toast({
              component: ToastificationContentCustom,
              props: {
                title: 'Successfully edited',
                text: `The Exercise For person <strong>${this.exercisedName}</strong> has been edited.`,
                icon: 'CheckCircleIcon',
                variant: 'success',
                hideClose: true,
              },
            })
            this.generateDeceasedData()
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
  },
}
</script>

  <style scoped>
    .flatpickr-current-month .flatpickr-monthDropdown-months span, .flatpickr-current-month .numInputWrapper span {
        display: inline-block;
        opacity: 1;
    }
    [dir=ltr] .numInputWrapper span {
        display: inline-block;
        opacity: 1;
    }
    .timeline-variant-info .timeline-item-point {
      background-color: #00cfe8 !important;
    }
    .low-opacity {
      opacity: 0.6;
    }
    .high-opacity div {
      opacity: 1 !important;
    }
    .padding-two {
      padding: 2rem !important;
    }
    .padding-one {
      padding: 1.5rem !important;
    }
    .shadow-background {
      background: #F5F8FB;
    }
    .purple-button {
      background: #9B5899 !important;
    }
    .purple-row {
      background: rgba(155, 88, 153, 0.12);
    }
    .no-background {
      background: none !important;
    }
    .background-card {
      background: #9FB8D8;
      border-radius: 6px;
    }

    .red-trash-button {
      color: #D91B35 !important;
    }
    .shadow-body {
      background: #FFFFFF;
      box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06) !important;
      border-radius: 6px;
      padding: 1.5rem !important;
    }

    .btn-group-toggle [class*=btn-outline-]:not(:last-child) {
      border-right-width: 1px !important;
    }

    .link-tag {
      color: #104D9D;
    }

    .autosuggest__results-container .autosuggest__results {
      background-color: #fff;
      margin-top: 1rem;
      border-radius: 0.5rem;
      -webkit-box-shadow: 0 15px 30px 0 rgba(0,0,0,.11),0 5px 15px 0 rgba(0,0,0,.08)!important;
      box-shadow: 0 15px 30px 0 rgba(0,0,0,.11),0 5px 15px 0 rgba(0,0,0,.08)!important;
    }
    .autosuggest__results-container .autosuggest__results {
      position: absolute;
      width: 100%;
      overflow-y: auto;
      max-height: 40vh;
    }
  </style>
